export const formatDateYMD = (date) => {
    const d = new Date(date);
    const day = (d.getDate() < 10 ? '0' : '') + d.getDate();
    const month = (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1);
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
};

export const normalizeDateToYMD = (dateStr) => {
    if (!dateStr) {
        return null;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return dateStr;
    }
    const slashMatch = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (slashMatch) {
        const [, month, day, year] = slashMatch;
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    const parsed = new Date(dateStr);
    if (!isNaN(parsed.getTime())) {
        return formatDateYMD(parsed);
    }
    return null;
};

const hasMeaningfulHolidayConfig = (holidayConfig) => {
    if (!holidayConfig || typeof holidayConfig !== 'object') {
        return false;
    }

    return ['open_hour_start', 'open_hour_end', 'working', 'closed'].some((key) => {
        const value = holidayConfig[key];
        return value !== undefined && value !== null && value !== '';
    });
};

export const findHolidayConfigForDate = (scheduleDate, holidayList = [], scheduledHoliday = []) => {
    const targetDate = formatDateYMD(scheduleDate);
    for (let i = 0; i < holidayList.length; i++) {
        const holidayDate = scheduledHoliday[i]?.date || holidayList[i]?.data;
        if (normalizeDateToYMD(holidayDate) === targetDate) {
            const holidayConfig = scheduledHoliday[i];
            if (hasMeaningfulHolidayConfig(holidayConfig)) {
                return holidayConfig;
            }
            return null;
        }
    }
    return null;
};

const findHourIndex = (time, hours) => {
    if (!time) {
        return '';
    }
    const index = Object.keys(hours).findIndex((hour) => hour === time);
    return index >= 0 ? index : '';
};

export const buildOpenHourDataForSchedule = (holidayConfig, weekdayData, hours) => {
    if (!holidayConfig) {
        return { ...weekdayData, isHoliday: false };
    }

    const open_hour_start_index = findHourIndex(holidayConfig.open_hour_start, hours);
    const open_hour_end_index = findHourIndex(holidayConfig.open_hour_end, hours);

    return {
        closed: holidayConfig.closed === 'on' ? 1 : '',
        working: holidayConfig.working === 'on' ? 1 : '',
        open_hour_start: holidayConfig.open_hour_start || '',
        open_hour_end: holidayConfig.open_hour_end || '',
        open_hour_start_index,
        open_hour_end_index,
        isHoliday: true,
    };
};

export const getOpenHourDataForDate = ({
    scheduleDate,
    weekdayData,
    holidayList,
    scheduledHoliday,
    hours,
}) => {
    const holidayConfig = findHolidayConfigForDate(scheduleDate, holidayList, scheduledHoliday);
    return buildOpenHourDataForSchedule(holidayConfig, weekdayData, hours);
};

const hasHourRange = (openHourData) => {
    const { open_hour_start_index, open_hour_end_index } = openHourData;
    return open_hour_start_index !== '' &&
        open_hour_start_index !== null &&
        open_hour_end_index !== '' &&
        open_hour_end_index !== null;
};

export const getDefaultAvailableHours = (openHourData, hourList, scheduleHourType) => {
    const isClosedDay = openHourData.closed === 1 || openHourData.closed === 'on';
    const isWorkingAllDay = openHourData.working === 1 || openHourData.working === 'on';

    if (Number(scheduleHourType) === 1) {
        if (isClosedDay) {
            return [];
        }
        if (isWorkingAllDay) {
            return hourList;
        }
        if (hasHourRange(openHourData)) {
            return hourList.filter(
                (_, index) =>
                    index >= openHourData.open_hour_start_index &&
                    index <= openHourData.open_hour_end_index
            );
        }
        return [];
    }

    if (Number(scheduleHourType) === 2) {
        if (isClosedDay) {
            return hourList;
        }
        if (isWorkingAllDay) {
            return [];
        }
        if (hasHourRange(openHourData)) {
            return hourList.filter(
                (_, index) =>
                    index < openHourData.open_hour_start_index ||
                    index > openHourData.open_hour_end_index
            );
        }
        return [];
    }

    return [];
};
